<template>
  <div id="creek-broadcast-page-container">
    <creek-audio-player-page :broadcast-id="$route.params.broadcastID"></creek-audio-player-page>
  </div>
</template>

<script type="text/javascript">

import mixins from '../util/mixins';
import JSONP from 'jsonp';

import AudioPlayerPage from './AudioPlayerPage'

export default {
  name: 'creek-broadcast-page-player',
  mixins: [mixins.routes],
  components: {
    'creek-audio-player-page': AudioPlayerPage
  },
  data () { 
    return { 
      html: '', 
      title: ''
    }
  },
  created () {
      console.log(1);        
    this.fetchData();
  },
  methods: {
    fetchData () {

      var URL = this.Creek.config.content.baseURLForAPI 
        + "/api/v2/broadcasts/" 
        + this.$route.params.broadcastID

      var _this = this;

      JSONP(URL, null, function(err, data) {
        console.log(data);
        _this.html = _this.Creek.util.fixLinks(data.html, "broadcast");
        // _this.setTitle(data.title);
        _this.swapPageClass("broadcast");
      })

    }
  }
}
</script>